import * as Vest from 'vest';
import CarSimYears from '../Model/CarSimYearModel';

export const FormSuite = Vest.create((data = {}) => {

    const carSimYears = new CarSimYears();

    Vest.test('catalogValue', 'ERROR_MUST_GT_0', () => {
        Vest.enforce(data.catalogValue).greaterThan(0);
    });

    Vest.test('co2Emission', 'ERROR_MUST_GT_EQ_0', () => {
        Vest.enforce(data.co2Emission).greaterThanOrEquals(0);
    });

    Vest.test('co2EmissionNew', 'ERROR_MUST_GT_EQ_0', () => {
        if(data?.falseHybrid)
        {
            Vest.enforce(data.co2EmissionNew).greaterThanOrEquals(0);
        }
    });

    Vest.test('personalContrib', 'ERROR_MUST_GT_EQ_0', () => {
        Vest.enforce(data.personalContrib).greaterThanOrEquals(0);
    });


    Vest.test('vehicleSeniority', 'DATE_FORMAT_INVALID', () => {
        Vest.enforce(data.vehicleSeniority).matches(/^(0?[1-9]|1[012])\/(\d{4})$/);
    });

    Vest.test('vehicleSeniority', 'ERROR_DATE_INCYEAR', () => {
        var incYear = carSimYears.years.find(x => x.value == data.incomeYear)?.label;

        var parts = data.vehicleSeniority.split('/');
        var year = parseInt(parts[1]);
        Vest.enforce(year).lessThanOrEquals(incYear);
    });


    Vest.test('VehicleAcquisitionDate', 'DATE_FORMAT_INVALID', () => {
        if(data.VehicleAcquisitionDate !== ""){
            Vest.enforce(data.VehicleAcquisitionDate).matches(/^(0?[1-9]|1[012])\/(\d{4})$/);
        }
    });

    Vest.test('VehicleAcquisitionDate', 'ERROR_DATE_ACQ_YEAR', () => {
        if(data.VehicleAcquisitionDate !== ""){
            var incYear = carSimYears.years.find(x => x.value == data.incomeYear)?.label;

            var parts = data.VehicleAcquisitionDate.split('/');
            var year = parseInt(parts[1]);
            Vest.enforce(year).lessThanOrEquals(incYear);
        }
    });

  });

  // https://react-hook-form.com/api/useform

// https://react-hook-form.com/ts

// https://vestjs.dev/docs/community_resources/integrations